<div class="popup box">
  <div class="d-flex flex-column align-items-center">
    <div class="mb-3 delete-popup__icon">
      <app-icon [name]="ICONS.TRASH"></app-icon>
    </div>
    <p class="mb-3 bold text-center">
      {{ mainText }}
    </p>
    <p class="mb-3 text-center text-color-light text-medium">
      {{ helperText }}
    </p>
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <app-button (click)="close()">
            {{ 'cancel' | t }}
          </app-button>
        </div>
        <div class="col-6">
          <app-button buttonStyle="danger" (click)="confirm()">
            {{ 'delete' | t }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
